module.exports = __webpack_public_path__ + "static/bg_Undead-0bf362f15f1f49c3c498641976970fb1.jpg";